const VALIDATION_EMAIL_REGEX = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/

export function validateEmail(email) {
  return VALIDATION_EMAIL_REGEX.test(email)
}
